export default __webpack_public_path__ + "static/media/betslipEmpty.9b4384f0.png";